import { ProductAttributeValue } from '@features/catalog/models/product-attribute-definition.models';
import { AttributeValueMutationResult } from '@features/catalog/models/product-attribute-value.models';
import {
  GraphqlMutationAttributeValuePayloadDto,
  GraphqlProductAttributeValueFullDto,
} from '../dto/product-attribute-value.dto';
import { normalizeGraphqlErrors } from './graphql-error.mapper';

export function mapProductAttributeValueDto(
  dto: GraphqlProductAttributeValueFullDto
): ProductAttributeValue {
  return {
    id: String(dto.id),
    value: dto.value,
    position: dto.position ?? null,
    active: dto.active ?? true,
    productAttributeDefinitionId:
      dto.productAttributeDefinitionId != null
        ? String(dto.productAttributeDefinitionId)
        : dto.productAttributeDefinition?.id != null
          ? String(dto.productAttributeDefinition.id)
          : null,
  };
}

export function mapMutationValuePayload(
  payload?: GraphqlMutationAttributeValuePayloadDto | null
): AttributeValueMutationResult {
  if (!payload) {
    return { value: null, errors: ['Respuesta vacía del servidor'] };
  }
  const errors = normalizeGraphqlErrors(payload.errors);
  const value = payload.attributeValue ? mapProductAttributeValueDto(payload.attributeValue) : null;
  return { value, errors };
}
